"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goodsApplicationFactsCompletenessOf = goodsApplicationFactsCompletenessOf;
exports.goodsInvoicedRootGroupsOf = goodsInvoicedRootGroupsOf;
exports.goodsInvoicedContributionsOf = goodsInvoicedContributionsOf;
exports.goodsInvoicedOf = goodsInvoicedOf;
const money_1 = require("./money");
function goodsApplicationFactsCompletenessOf(subject) {
    return subject.kind === 'final' &&
        subject.provenance === 'projected' &&
        subject.anchorKey !== null &&
        subject.exactProvisionalApplicationCount === 0
        ? 'legacy'
        : 'exact';
}
function isGoodsRoot(kind) {
    return kind === 'provisional' || kind === 'final';
}
function isGoodsNote(kind) {
    return kind === 'credit_note' || kind === 'debit_note';
}
function eventualGoodsRootOf(note, byId) {
    const visited = new Set([note.documentId]);
    let parentId = note.adjustsDocumentId;
    while (parentId !== null && !visited.has(parentId)) {
        visited.add(parentId);
        const parent = byId.get(parentId);
        if (parent === undefined)
            return null;
        if (isGoodsRoot(parent.kind))
            return parent;
        if (!isGoodsNote(parent.kind))
            return null;
        parentId = parent.adjustsDocumentId;
    }
    return null;
}
function exactReplacedProvisionalIdsOf(goodsRoots, byId) {
    const replacedIds = new Set();
    for (const final of goodsRoots.filter((root) => root.kind === 'final' && root.applicationFacts === 'exact')) {
        for (const deduction of final.deductions) {
            if (byId.get(deduction.documentId)?.kind === 'provisional') {
                replacedIds.add(deduction.documentId);
            }
        }
    }
    return replacedIds;
}
function legacyReplacedProvisionalIdsOf(goodsRoots) {
    const legacyFinalAnchors = new Set(goodsRoots.flatMap((root) => root.kind === 'final' &&
        root.provenance === 'projected' &&
        root.applicationFacts === 'legacy' &&
        root.anchorKey !== null
        ? [root.anchorKey]
        : []));
    return new Set(goodsRoots.flatMap((root) => root.kind === 'provisional' &&
        root.provenance === 'projected' &&
        root.anchorKey !== null &&
        legacyFinalAnchors.has(root.anchorKey)
        ? [root.documentId]
        : []));
}
function goodsInvoicedRootGroupsOf(documents, anchorKey) {
    const effective = documents.filter((document) => document.entersSum);
    const byId = new Map(effective.map((document) => [document.documentId, document]));
    const goodsRoots = effective.filter((document) => isGoodsRoot(document.kind));
    const replacedIds = new Set([
        ...exactReplacedProvisionalIdsOf(goodsRoots, byId),
        ...legacyReplacedProvisionalIdsOf(goodsRoots),
    ]);
    const liveRoots = goodsRoots.filter((root) => !replacedIds.has(root.documentId) &&
        (anchorKey === undefined || root.anchorKey === anchorKey));
    const notesByRoot = new Map();
    for (const note of effective.filter((document) => isGoodsNote(document.kind))) {
        const root = eventualGoodsRootOf(note, byId);
        if (root === null)
            continue;
        const notes = notesByRoot.get(root.documentId) ?? [];
        notes.push(note);
        notesByRoot.set(root.documentId, notes);
    }
    return liveRoots.map((root) => ({
        root,
        notes: notesByRoot.get(root.documentId) ?? [],
    }));
}
function signedByRoot(amount, root) {
    const magnitude = (0, money_1.absMoney)(amount);
    return (0, money_1.isNegativeMoney)(root.considerationAmount) ? (0, money_1.negateMoney)(magnitude) : magnitude;
}
function goodsInvoicedContributionsOf(documents, anchorKey) {
    return goodsInvoicedRootGroupsOf(documents, anchorKey).flatMap(({ root, notes }) => [
        ...(root.grossTotal === null
            ? [
                signedByRoot(root.considerationAmount, root),
                ...root.deductions.map((deduction) => signedByRoot(deduction.amount, root)),
            ]
            : [signedByRoot(root.grossTotal, root)]),
        ...notes.map((note) => note.considerationAmount),
    ]);
}
function goodsInvoicedOf(documents, anchorKey) {
    const contributions = goodsInvoicedContributionsOf(documents, anchorKey);
    return contributions.length === 0 ? money_1.ZERO_MONEY : (0, money_1.sumMoney)(contributions);
}
//# sourceMappingURL=goods-invoiced.js.map